<template>
    <div>
        <nav aria-label="items-project">
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-general-tab" data-toggle="tab" href="#nav-general" role="tab"
                    aria-controls="nav-general" aria-selected="true">Datos Generales</a>
                <a class="nav-item nav-link" id="nav-questions-tab" data-toggle="tab" href="#nav-questions" role="tab"
                    aria-controls="nav-questions" aria-selected="false">Preguntas</a>
                <a class="nav-item nav-link" id="nav-team-tab" data-toggle="tab" href="#nav-team" role="tab"
                    aria-controls="nav-team" aria-selected="false">Equipo</a>
            </div>
        </nav>

        <ValidationObserver v-slot="{ invalid }">
            <div class="tab-content" id="nav-tabContent" v-if="!isContest2024()">
                <div class="tab-pane fade show active" id="nav-general" role="tabpanel" aria-labelledby="nav-general-tab">
                    <span class="badge badge-info p-2 text-light mb-2">Última modificación: {{ model.updated_at }}</span>
                    <div>
                        <div class="row row-cols-1 row-cols-md-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">ID</label>
                                    <input type="text" class="form-control" :value="model.id ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">ID Post Asignado en Comunidad</label>
                                    <input type="text" class="form-control" :value="model.community_post_id ?? '-'"
                                        readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Estado</label>
                                    <input type="text" class="form-control" :value="model.is_completed &&
                                        model.is_full_information
                                        ? 'Completo'
                                        : 'Incompleto'
                                        " readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="concurso">Concurso</label>
                                    <input type="text" class="form-control" :value="model.contest_name ?? '-'" readonly />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-md-3">
                            <ValidationProvider rules="required" name="nombre emprendimiento" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Nombre Emprendimiento
                                        <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" v-model="model.name" />
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>

                            <ValidationProvider rules="required" name="pais" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="origin_country">Pais
                                        <span class="text-danger">*</span></label>
                                    <select class="form-control" id="origin_country" v-model="model.country_id">
                                        <option value="">
                                            Elija una opción
                                        </option>
                                        <option :value="country.id" v-for="country in arrayCountries" :key="country.id">
                                            {{ country.name }}
                                        </option>
                                    </select>
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>

                            <div class="form-group col">
                                <label for="send_community_confirm">Proyecto Migrado a Comunidad</label>
                                <input type="text" class="form-control" :value="model.send_community_confirm ?? '-'"
                                    readonly />
                            </div>
                        </div>
                        <div class="row row-cols-1 row-cols-md-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Url Pagina web
                                        <a v-if="model.web_site" :href="model.web_site" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.web_site" />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Url Facebook
                                        <a v-if="model.facebook" :href="model.facebook" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.facebook" />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Url Instagram
                                        <a v-if="model.instagram" :href="model.instagram" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.instagram" />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-md-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Url Twitter
                                        <a v-if="model.twitter" :href="model.twitter" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.twitter" />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Url LinkedIn
                                        <a v-if="model.linkedin" :href="model.linkedin" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.linkedin" />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Url TikTok
                                        <a v-if="model.tiktok" :href="model.tiktok" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.tiktok" />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-md-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Url YouTube
                                        <a v-if="model.youtube" :href="model.youtube" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.youtube" />
                                </div>
                            </span>
                            <ValidationProvider rules="required" name="url pitch" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Url Pitch
                                        <span class="text-danger">*</span>
                                        <a v-if="model.video" :href="model.video" target="_blank" rel="noopener noreferrer">
                                            (Ver video)</a></label>
                                    <input type="text" class="form-control" v-model="model.video" />
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider rules="required" name="url imagen equipo" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Url Imagen Equipo
                                        <span class="text-danger">*</span>
                                        <a v-if="model.image_url" :href="model.image_url" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver imagen)</a></label>
                                    <input type="text" class="form-control" v-model="model.image_url" />
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider rules="required" name="url logo equipo" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Url Logo Equipo
                                        <span class="text-danger">*</span>
                                        <a v-if="model.logo_url" :href="model.logo_url" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver Logo)</a></label>
                                    <input type="text" class="form-control" v-model="model.logo_url" />
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="row row-cols-1">
                            <span>
                                <div class="form-group col">
                                    <label for="">Subir Imagen Equipo</label>
                                    <vue-dropzone ref="teamPhoto" id="teamPhoto" :options="dropzoneOptions"
                                        @vdropzone-complete="afterUploadComplete
                                            "></vue-dropzone>
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1">
                            <div class="col-sm-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h6 class="font-weight-bold">
                                            Proyecto {{ model.id ?? "-" }} |
                                            Soporte para migración a comunidad
                                        </h6>
                                        <p class="m-0">
                                            En esta sección puede modificar los
                                            parámetros requeridos para realizar
                                            la migración de proyectos
                                            registrados a la plataforma de
                                            SocialSkin Comunidad. Igualmente
                                            validar que toda la información que
                                            aparece en este modulo de edición de
                                            encuentre correctamente diligenciada
                                            antes de realizar el procedimiento.
                                        </p>
                                    </div>

                                    <div class="card-body">
                                        <div class="px-3 d-flex flex-column">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_full_information"
                                                    v-model="model.is_full_information
                                                        " :checked="model.is_full_information
        " />
                                                <label class="custom-control-label" for="is_full_information">Esta completa
                                                    toda la
                                                    información
                                                    (Obligatorio)</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_completed"
                                                    v-model="model.is_completed" :checked="model.is_completed
                                                        " />
                                                <label class="custom-control-label" for="is_completed">Esta completo
                                                    (Obligatorio)</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    id="is_general_completed" v-model="model.is_general_completed
                                                        " :checked="model.is_general_completed
        " />
                                                <label class="custom-control-label" for="is_general_completed">Esta completa
                                                    la
                                                    información general
                                                    (Obligatorio)</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_model_completed"
                                                    v-model="model.is_model_completed
                                                        " :checked="model.is_model_completed
        " />
                                                <label class="custom-control-label" for="is_model_completed">Esta el modelo
                                                    completo
                                                    (Obligatorio)</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_team_completed"
                                                    v-model="model.is_team_completed
                                                        " :checked="model.is_team_completed
        " />
                                                <label class="custom-control-label" for="is_team_completed">Esta el equipo
                                                    completo
                                                    (Obligatorio)</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="send_community"
                                                    v-model="model.send_community
                                                        " :checked="model.send_community
        " />
                                                <label class="custom-control-label" for="send_community">Fue migrado a
                                                    comunidad
                                                    (Desactívelo si desea volver
                                                    a migrarlo a
                                                    comunidad)</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row row-cols-1">
                            <div class="col-sm-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h6 class="font-weight-bold">
                                            Mas opciones
                                        </h6>
                                        <p class="m-0">
                                            En esta sección puede modificar
                                            parámetros puntuales sobre el
                                            proyecto.
                                        </p>
                                    </div>

                                    <div class="card-body">
                                        <div class="px-3 d-flex flex-column">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_active"
                                                    v-model="model.is_active" :checked="model.is_active" />
                                                <label class="custom-control-label" for="is_active">Esta activo</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_winner"
                                                    v-model="model.is_winner" :checked="model.is_winner" />
                                                <label class="custom-control-label" for="is_winner">Es ganador</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_finalist"
                                                    v-model="model.is_finalist" :checked="model.is_finalist" />
                                                <label class="custom-control-label" for="is_finalist">Es finalista</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_junior"
                                                    v-model="model.is_junior" :checked="model.is_junior" />
                                                <label class="custom-control-label" for="is_junior">Proyecto en
                                                    evolución</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade" id="nav-questions" role="tabpanel" aria-labelledby="nav-questions-tab">
                    <div>
                        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2">
                            <span>
                                <div class="form-group col">
                                    <label for="project_phase">Etapa del emprendimiento</label>
                                    <select class="form-control" id="project_phase" v-model="model.project_phase_id">
                                        <option value="">
                                            Elija una opción
                                        </option>
                                        <option :value="phase.id" v-for="phase in arrayProjectPhases" :key="phase.id">
                                            {{ phase.description }}
                                        </option>
                                    </select>
                                </div>
                            </span>
                            <ValidationProvider rules="required" name="categoria" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="category">Categoria
                                        <span class="text-danger">*</span></label>
                                    <select class="form-control" id="category" v-model="model.category_id">
                                        <option value="">
                                            Elija una opción
                                        </option>
                                        <option :value="category.id" v-for="category in arrayCategories" :key="category.id">
                                            {{ category.name }}
                                        </option>
                                    </select>
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                            <span>
                                <div class="form-group col">
                                    <label for="scope_of_business">Alcance del emprendimiento</label>
                                    <select class="form-control" id="scope_of_business" v-model="model.scope_of_business">
                                        <option value="">
                                            Elija una opción
                                        </option>
                                        <option :value="level.id" v-for="level in levelImplementation" :key="level.id">
                                            {{ level.name }}
                                        </option>
                                    </select>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="annual_sale">Nivel de ventas / ingresos
                                        anuales</label>
                                    <select class="form-control" id="annual_sale" v-model="model.annual_sale_id">
                                        <option value="">
                                            Elija una opción
                                        </option>
                                        <option :value="sales.id" v-for="sales in arrayAnnualSales" :key="sales.id">
                                            {{ sales.name }}
                                        </option>
                                    </select>
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Describe el emprendimiento</label>
                                    <textarea class="form-control" rows="5" v-model="model.initiative"></textarea>
                                </div>
                            </span>
                            <ValidationProvider rules="required" name="caracteristicas diferenciales" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Caracteristicas diferenciales
                                        <span class="text-danger">*</span></label>
                                    <textarea class="form-control" rows="5" v-model="model.solve_what"></textarea>
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider rules="required" name="problematica que resuelve" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Problematica que resuelve
                                        <span class="text-danger">*</span></label>
                                    <textarea class="form-control" rows="5" v-model="model.solve_how"></textarea>
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Momento de revelación</label>
                                    <textarea class="form-control" rows="5"
                                        v-model="model.initiative_explanation"></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="expand_explain">El emprendimiento se puede
                                        expandir</label>
                                    <textarea id="expand_explain" class="form-control" rows="5"
                                        v-model="model.expand_explain"></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Población que esta impactando</label>
                                    <textarea class="form-control" rows="5" v-model="model.problem_population"></textarea>
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Áreas del emprendimiento</label>
                                    <textarea class="form-control" rows="5" :value="model.areas ?? '-'" readonly></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Porqué quieres ser parte de
                                        Social-Skin</label>
                                    <textarea class="form-control" rows="5" :value="model.why_chose_socialskin"
                                        readonly></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Tipo y cantidad de clientes
                                        actuales</label>
                                    <textarea class="form-control" rows="5" :value="model.clients_type ?? '-'"
                                        readonly></textarea>
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1">
                            <span>
                                <div class="form-group col-lg-8 col col-sm">
                                    <label>Información adicional</label>
                                    <textarea class="form-control" rows="5"
                                        v-model="model.adittional_information"></textarea>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade" id="nav-team" role="tabpanel" aria-labelledby="nav-team-tab">
                    <div v-for="team in model.team_full" :key="team.id" class="mb-3">
                        <h4>Integrante {{ team.id }}</h4>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Nombres</label>
                                    <input type="text" class="form-control" :value="team.name ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Apellidos</label>
                                    <input type="text" class="form-control" :value="team.lastname ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Pais</label>
                                    <input type="text" class="form-control" :value="team.residence_country_name ?? '-'
                                        " readonly />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Ciudad</label>
                                    <input type="text" class="form-control" :value="team.residence_city ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Email</label>
                                    <input type="text" class="form-control" :value="team.email ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Teléfono</label>
                                    <input type="text" class="form-control" :value="team.phone_number_format ?? '-'"
                                        readonly />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Fecha Nacimiento</label>
                                    <input type="text" class="form-control" :value="team.birth_date ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Identificación</label>
                                    <input type="text" class="form-control" :value="team.document_number ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Rol</label>
                                    <input type="text" class="form-control" :value="team.rol ?? '-'" readonly />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Evidencia Documento
                                        <a v-if="team.document_evidence" :href="team.document_evidence_url" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" :value="team.document_evidence_url ?? '-'
                                        " readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Evidencia Autorización
                                        <a v-if="team.document_evidence" :href="team.document_evidence_url" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" :value="team.document_evidence_url ?? '-'
                                        " readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Edad</label>
                                    <input type="text" class="form-control" :value="team.age ?? '-'" readonly />
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-content" id="nav-tabContent" v-if="isContest2024()">
                <div class="tab-pane fade show active" id="nav-general" role="tabpanel" aria-labelledby="nav-general-tab">
                    <span class="badge badge-info p-2 text-light mb-2">Última modificación: {{ model.updated_at }}</span>
                    <div>

                        <div class="row row-cols-1 row-cols-md-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">ID</label>
                                    <input type="text" class="form-control" :value="model.id ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">ID Post Asignado en Comunidad</label>
                                    <input type="text" class="form-control" :value="model.community_post_id ?? '-'"
                                        readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Estado</label>
                                    <input type="text" class="form-control" :value="model.is_completed &&
                                        model.is_full_information
                                        ? 'Completo'
                                        : 'Incompleto'
                                        " readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="concurso">Concurso</label>
                                    <input type="text" class="form-control" :value="model.contest_name ?? '-'" readonly />
                                </div>
                            </span>
                        </div>

                        <div class="row row-cols-1 row-cols-md-3">
                            <ValidationProvider rules="required" name="nombre emprendimiento" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Nombre Emprendimiento
                                        <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" v-model="model.name" />
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>

                            <ValidationProvider rules="required" name="pais" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="origin_country">Pais
                                        <span class="text-danger">*</span></label>
                                    <select class="form-control" id="origin_country" v-model="model.country_id">
                                        <option value="">
                                            Elija una opción
                                        </option>
                                        <option :value="country.id" v-for="country in arrayCountries" :key="country.id">
                                            {{ country.name }}
                                        </option>
                                    </select>
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>

                            <div class="form-group col">
                                <label for="send_community_confirm">Proyecto Migrado a Comunidad</label>
                                <input type="text" class="form-control" :value="model.send_community_confirm ?? '-'"
                                    readonly />
                            </div>
                        </div>
                        <div class="row row-cols-1 row-cols-md-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Url Pagina web
                                        <a v-if="model.web_site" :href="model.web_site" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.web_site" />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Url Facebook
                                        <a v-if="model.facebook" :href="model.facebook" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.facebook" />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Url Instagram
                                        <a v-if="model.instagram" :href="model.instagram" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.instagram" />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-md-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Url Twitter
                                        <a v-if="model.twitter" :href="model.twitter" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.twitter" />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Url LinkedIn
                                        <a v-if="model.linkedin" :href="model.linkedin" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.linkedin" />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Url Google Play
                                        <a v-if="model.google_play" :href="model.google_play" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.google_play" />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-md-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Url App Store
                                        <a v-if="model.app_store" :href="model.app_store" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.app_store" />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Url YouTube
                                        <a v-if="model.youtube" :href="model.youtube" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.youtube" />
                                </div>
                            </span><span>
                                <div class="form-group col">
                                    <label for="">Pitch Deck
                                        <a v-if="model.file_url" :href="model.file_url" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" v-model="model.file_url" />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-md-3">
                            <ValidationProvider rules="required" name="url pitch" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Url Pitch
                                        <span class="text-danger">*</span>
                                        <a v-if="model.video" :href="model.video" target="_blank" rel="noopener noreferrer">
                                            (Ver video)</a></label>
                                    <input type="text" class="form-control" v-model="model.video" />
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider rules="required" name="url logo equipo" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Url Logo Equipo
                                        <span class="text-danger">*</span>
                                        <a v-if="model.logo_url" :href="model.logo_url" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver Logo)</a></label>
                                    <input type="text" class="form-control" v-model="model.logo_url" />
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider rules="required" name="url imagen equipo" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Url Imagen Equipo
                                        <span class="text-danger">*</span>
                                        <a v-if="model.image_url" :href="model.image_url" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver imagen)</a></label>
                                    <input type="text" class="form-control" v-model="model.image_url" />
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                        </div>

                        <div class="row row-cols-1">
                            <span>
                                <div class="form-group col">
                                    <label for="">Subir Imagen Equipo</label>
                                    <vue-dropzone ref="teamPhoto" id="teamPhoto" :options="dropzoneOptions"
                                        @vdropzone-complete="afterUploadComplete
                                            "></vue-dropzone>
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1">
                            <div class="col-sm-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h6 class="font-weight-bold">
                                            Proyecto {{ model.id ?? "-" }} |
                                            Soporte para migración a comunidad
                                        </h6>
                                        <p class="m-0">
                                            En esta sección puede modificar los
                                            parámetros requeridos para realizar
                                            la migración de proyectos
                                            registrados a la plataforma de
                                            SocialSkin Comunidad. Igualmente
                                            validar que toda la información que
                                            aparece en este modulo de edición de
                                            encuentre correctamente diligenciada
                                            antes de realizar el procedimiento.
                                        </p>
                                    </div>

                                    <div class="card-body">
                                        <div class="px-3 d-flex flex-column">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_full_information"
                                                    v-model="model.is_full_information
                                                        " :checked="model.is_full_information
        " />
                                                <label class="custom-control-label" for="is_full_information">Esta completa
                                                    toda la
                                                    información
                                                    (Obligatorio)</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_completed"
                                                    v-model="model.is_completed" :checked="model.is_completed
                                                        " />
                                                <label class="custom-control-label" for="is_completed">Esta completo
                                                    (Obligatorio)</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    id="is_general_completed" v-model="model.is_general_completed
                                                        " :checked="model.is_general_completed
        " />
                                                <label class="custom-control-label" for="is_general_completed">Esta completa
                                                    la
                                                    información general
                                                    (Obligatorio)</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_model_completed"
                                                    v-model="model.is_model_completed
                                                        " :checked="model.is_model_completed
        " />
                                                <label class="custom-control-label" for="is_model_completed">Esta el modelo
                                                    completo
                                                    (Obligatorio)</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_team_completed"
                                                    v-model="model.is_team_completed
                                                        " :checked="model.is_team_completed
        " />
                                                <label class="custom-control-label" for="is_team_completed">Esta el equipo
                                                    completo
                                                    (Obligatorio)</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="send_community"
                                                    v-model="model.send_community
                                                        " :checked="model.send_community
        " />
                                                <label class="custom-control-label" for="send_community">Fue migrado a
                                                    comunidad
                                                    (Desactívelo si desea volver
                                                    a migrarlo a
                                                    comunidad)</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row row-cols-1">
                            <div class="col-sm-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h6 class="font-weight-bold">
                                            Mas opciones
                                        </h6>
                                        <p class="m-0">
                                            En esta sección puede modificar
                                            parámetros puntuales sobre el
                                            proyecto.
                                        </p>
                                    </div>

                                    <div class="card-body">
                                        <div class="px-3 d-flex flex-column">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_active"
                                                    v-model="model.is_active" :checked="model.is_active" />
                                                <label class="custom-control-label" for="is_active">Esta activo</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_winner"
                                                    v-model="model.is_winner" :checked="model.is_winner" />
                                                <label class="custom-control-label" for="is_winner">Es ganador</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_finalist"
                                                    v-model="model.is_finalist" :checked="model.is_finalist" />
                                                <label class="custom-control-label" for="is_finalist">Es finalista</label>
                                            </div>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="is_junior"
                                                    v-model="model.is_junior" :checked="model.is_junior" />
                                                <label class="custom-control-label" for="is_junior">Proyecto en
                                                    evolución</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade" id="nav-questions" role="tabpanel" aria-labelledby="nav-questions-tab">
                    <div>
                        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2">
                            <span>
                                <div class="form-group col">
                                    <label for="project_phase">Etapa del emprendimiento</label>
                                    <select class="form-control" id="project_phase" v-model="model.project_phase_id">
                                        <option value="">
                                            Elija una opción
                                        </option>
                                        <option :value="phase.id" v-for="phase in arrayProjectPhases" :key="phase.id">
                                            {{ phase.description }}
                                        </option>
                                    </select>
                                </div>
                            </span>
                            <ValidationProvider rules="required" name="categoria" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="category">Categoria
                                        <span class="text-danger">*</span></label>
                                    <select class="form-control" id="category" v-model="model.category_id">
                                        <option value="">
                                            Elija una opción
                                        </option>
                                        <option :value="category.id" v-for="category in arrayCategories" :key="category.id">
                                            {{ category.name }}
                                        </option>
                                    </select>
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                            <span>
                                <div class="form-group col">
                                    <label for="scope_of_business">Alcance del emprendimiento</label>
                                    <select class="form-control" id="scope_of_business" v-model="model.scope_of_business">
                                        <option value="">
                                            Elija una opción
                                        </option>
                                        <option :value="level.id" v-for="level in levelImplementation" :key="level.id">
                                            {{ level.name }}
                                        </option>
                                    </select>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="annual_sale">Nivel de ventas / ingresos
                                        mensuales</label>
                                    <select class="form-control" id="annual_sale" v-model="model.annual_sale_id">
                                        <option value="">
                                            Elija una opción
                                        </option>
                                        <option :value="sales.id" v-for="sales in arrayAnnualSales" :key="sales.id">
                                            {{ sales.name }}
                                        </option>
                                    </select>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="age_range">Rango edad</label>
                                    <select class="form-control" id="age_range" v-model="model.age_range_id">
                                        <option value="">
                                            Elija una opción
                                        </option>
                                        <option :value="ages.id" v-for="ages in arrayAges" :key="ages.id">
                                            {{ ages.description }}
                                        </option>
                                    </select>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="apply_patent_process">Proceso patente</label>
                                    <select class="form-control" id="apply_patent_process"
                                        v-model="model.apply_patent_process">
                                        <option value="">
                                            Elija una opción
                                        </option>
                                        <option value="0">
                                            No
                                        </option>
                                        <option value="1">
                                            Si
                                        </option>
                                        <option value="2">
                                            En Proceso
                                        </option>
                                    </select>
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Numero de Radicado de Patente</label>
                                    <textarea 
                                        class="form-control" 
                                        rows="5" 
                                        v-model="model.patent_filing_number">
                                    </textarea>
                                </div>
                            </span>
                            <ValidationProvider rules="required" name="describe el emprendimiento" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Describe el emprendimiento
                                        <span class="text-danger">*</span></label>
                                    <textarea class="form-control" rows="5" v-model="model.solve_how"></textarea>
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider rules="required" name="problematica que resuelve" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Problematica que resuelve
                                        <span class="text-danger">*</span></label>
                                    <textarea class="form-control" rows="5" v-model="model.solve_what"></textarea>
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Población que esta impactando</label>
                                    <textarea class="form-control" rows="5" v-model="model.problem_population"></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Monetización emprendimento</label>
                                    <textarea class="form-control" rows="5" v-model="model.which_source_income"></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="number_people">Número de personas en el emprendimiento</label>
                                    <textarea id="number_people" class="form-control" rows="5"
                                        v-model="model.number_people"></textarea>
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <ValidationProvider rules="required" name="caracteristicas diferenciales" v-slot="{ errors }">
                                <div class="form-group col">
                                    <label for="">Explicación diferenciales
                                        <span class="text-danger">*</span></label>
                                    <textarea class="form-control" rows="5" v-model="model.differentiator"></textarea>
                                    <span class="text-danger mt-1">{{
                                        errors[0]
                                    }}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <div class="form-group col">
                                <label for="">Modelo de negocio integrado al impacto</label>
                                <textarea class="form-control" rows="5" v-model="model.impact_integrated_business_model"></textarea>
                            </div>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <div class="form-group col">
                                <label for="">Evidencia de que el producto funciona</label>
                                <textarea class="form-control" rows="5" v-model="model.evidence_product_works"></textarea>
                            </div>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Emprendimiento en otros paises</label>
                                    <textarea class="form-control" rows="5" :value="setOtherCountriesText()"
                                        readonly></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Selección diferenciales</label>
                                    <textarea class="form-control" rows="5" :value="setDifferentiatorsChecksText()"
                                        readonly></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Tipo y cantidad de clientes
                                        actuales</label>
                                    <textarea class="form-control" rows="5" :value="setClientsText()" readonly></textarea>
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Desarrollo propio para resolver problematica</label>
                                    <textarea class="form-control" rows="5"
                                        :value="model['prototype'] ? `Si; ${model['prototype']}` : 'No'"
                                        readonly></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Emprendimiento registrado</label>
                                    <textarea class="form-control" rows="5" :value="model.chamber_commerce ? 'Si' : 'No'"
                                        readonly></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Evidencia de registro</label>
                                    <textarea class="form-control" rows="5" :value="model.chamber_commerce ?? '-'"
                                        readonly></textarea>
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Reconocimientos del emprendimiento</label>
                                    <textarea class="form-control" rows="5" :value="setRecognitionText()"
                                        readonly></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Tipo de Inversión</label>
                                    <textarea class="form-control" rows="5" :value="setInvestmentText()"
                                        readonly></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">¿De Donde Viene la Inversión?</label>
                                    <textarea class="form-control" rows="5" :value="model.investment_from ?? '-'"
                                        readonly></textarea>
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Principales competidores</label>
                                    <textarea class="form-control" rows="5" :value="setCompetitorsText()"
                                        readonly></textarea>
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1">
                            <span>
                                <div class="form-group col-lg-8 col col-sm">
                                    <label>Información adicional</label>
                                    <textarea class="form-control" rows="5"
                                        v-model="model.adittional_information"></textarea>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade" id="nav-team" role="tabpanel" aria-labelledby="nav-team-tab">
                    <div v-for="team in model.team_full" :key="team.id" class="mb-3">
                        <h4>Integrante {{ team.id }}</h4>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Nombres</label>
                                    <input type="text" class="form-control" :value="team.name ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Apellidos</label>
                                    <input type="text" class="form-control" :value="team.lastname ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Pais</label>
                                    <input type="text" class="form-control" :value="team.residence_country_name ?? '-'
                                        " readonly />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Ciudad</label>
                                    <input type="text" class="form-control" :value="team.residence_city ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Email</label>
                                    <input type="text" class="form-control" :value="team.email ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Teléfono</label>
                                    <input type="text" class="form-control" :value="team.phone_number_format ?? '-'"
                                        readonly />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Fecha Nacimiento</label>
                                    <input type="text" class="form-control" :value="team.birth_date ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Identificación</label>
                                    <input type="text" class="form-control" :value="team.document_number ?? '-'" readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Rol</label>
                                    <input type="text" class="form-control" :value="team.rol ?? '-'" readonly />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Evidencia Documento
                                        <a v-if="team.document_evidence" :href="team.document_evidence_url" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" :value="team.document_evidence_url ?? '-'
                                        " readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Evidencia Autorización
                                        <a v-if="team.document_evidence" :href="team.document_evidence_url" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" :value="team.document_evidence_url ?? '-'
                                        " readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Edad</label>
                                    <input type="text" class="form-control" :value="team.age ?? '-'" readonly />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Nivel educativo actual</label>
                                    <input type="text" class="form-control" :value="team.education_level_name ?? '-'"
                                        readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Institución último estudio</label>
                                    <input type="text" class="form-control" :value="team.other_university ?? '-'"
                                        readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Área o carrera</label>
                                    <input type="text" class="form-control" :value="team.study_what ?? '-'" readonly />
                                </div>
                            </span>
                        </div>
                        <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                            <span>
                                <div class="form-group col">
                                    <label for="">Link de Linkedin
                                        <a v-if="team.linkedin" :href="team.linkedin" target="_blank"
                                            rel="noopener noreferrer">
                                            (Ver)</a></label>
                                    <input type="text" class="form-control" :value="team.linkedin ?? '-'
                                        " readonly />
                                </div>
                            </span>
                            <span>
                                <div class="form-group col">
                                    <label for="">Tiempo de dedicación al emprendimiento</label>
                                    <input type="text" class="form-control" :value="team.dedication_time_quantity ?? '-'"
                                        readonly />
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-right mt-2">
                <button class="btn btn-light" type="button" @click="handleUpdateProjectInCommunity(model.id)"
                    v-if="model.community_post_id">
                    Actualizar proyecto en comunidad
                </button>

                <button class="btn btn-success" type="button" @click="updateProject" :disabled="invalid">
                    Actualizar
                </button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import helpers from "../../mixins/index";

export default {
    name: "ProjectEditForm",
    mixins: [helpers],
    components: {
        vueDropzone: vue2Dropzone,
    },
    props: {
        model_id: Number,
    },
    data() {
        return {
            category_name: [],
            arrayCategories: [],
            arrayCountries: [],
            arrayProjectPhases: [],
            arrayAnnualSales: [],
            arrayAges: [],
            arrayOtherCountries: [],
            model: {},
            levelImplementation: [
                { id: 1, name: "Barrio" },
                { id: 2, name: "Ciudad - Pueblo" },
                { id: 3, name: "Dpto" },
                { id: 4, name: "País" },
                { id: 5, name: "Mundo" },
            ],
            dropzoneOptions: {
                url: this.getUploadImageUrl(),
                maxFilesize: 2048,
                paramName: "qqfile",
                disablePreviews: true,
                addRemoveLinks: true,
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/projects/show/" + me.model_id)
                .then(function (response) {
                    me.model = response.data;
                })
                .catch(function (error) { });
        },

        getListCountries() {
            let me = this;
            axios
                .get("/api/countries?paginate=false")
                .then(function (response) {
                    me.arrayCountries = response.data;
                })
                .catch(function (error) { });
        },

        getListCategories() {
            let me = this;
            axios
                .get("/api/categories?paginate=false")
                .then(function (response) {
                    me.arrayCategories = response.data;
                    me.model.category_name = me.arrayCategories.find(
                        (option) => option.id === me.model.category_id
                    );
                })
                .catch(function (error) { });
        },

        getProjectPhasesList() {
            let me = this;
            axios
                .get("/api/project-phases?paginate=false")
                .then(function (response) {
                    me.arrayProjectPhases = response.data;
                })
                .catch(function (error) { });
        },

        getAnnualSalesList() {
            let me = this;
            axios
                .get("/api/annual-sales?paginate=false")
                .then(function (response) {
                    me.arrayAnnualSales = response.data;
                })
                .catch(function (error) { });
        },

        getAgesList() {
            let me = this;
            axios
                .get("/api/age_range")
                .then(function (response) {
                    me.arrayAges = response.data;
                })
                .catch(function (error) { });
        },

        getOtherCountriesList() {
            let me = this;
            axios
                .get("/api/birth-country")
                .then(function (response) {
                    me.arrayOtherCountries = response.data.result;
                })
                .catch(function (error) { });
        },

        updateProject() {
            const me = this;
            me.loading();

            axios
                .put(`/api/projects/update/${me.model_id}`, me.model)
                .then(function (response) {
                    me.closeLoading();
                    me.showActionSuccess("Actualizacion exitosa!");
                })
                .catch(function (error) {
                    let content = "";

                    if (error.response.status === 422) {
                        if (
                            typeof error.response?.data?.messages === "string"
                        ) {
                            content = error.response?.data?.messages;
                        } else {
                            const errors = Object.values(
                                error.response?.data?.messages
                            );
                            content = errors
                                .map((item) => `<li>${item}</li>`)
                                .join("");
                        }
                        me.showSwalError(`<ul>${content}</ul>`);
                    } else {
                        me.showSwalError(
                            "No fue posible procesar su solicitud, intente mas tarde."
                        );
                    }
                });
        },

        afterUploadComplete: async function (response) {
            if (response.status === "success") {
                const data = JSON.parse(response.xhr.response);
                this.model.image = data.path;
                this.model.image_url = data.url;
                this.showActionSuccess("Carga de imagen exitosa!");
            } else {
                const e = document.querySelector(".dz-error-message");
                e.remove();
                this.showActionError("Carga de imagen fallo!");
            }
        },

        handleUpdateProjectInCommunity(projectId = null) {
            this.$swal({
                text: "¿Estas seguro de ejecutar esta actualización en Comunidad?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3490DC",
                cancelButtonColor: "#6c757d",
                confirmButtonText: "Si, Actualizar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.isConfirmed) {
                    const me = this;
                    me.loading();
                    axios
                        .put(`/api/projects/update-project-in-community/${projectId}`)
                        .then(function (response) {
                            const { data } = response.data;
                            if (data.success) {
                                me.showAlert(
                                    "success",
                                    `Actualización realizada en comunidad.`,
                                    `${data.message}`
                                );
                            }
                        })
                        .catch(function (error) {
                            me.showAlert(
                                "error",
                                "Ha ocurrido un error",
                                error?.response?.data?.message ??
                                error?.response?.data?.messages
                            );
                        })
                        .finally(() => {
                            me.closeLoading();
                        });
                }
            });
        },

        isContest2024() {
            const me = this;
            if (me.model.created_at) {
                const date = new Date(me.model.created_at);
                const year = date.getFullYear();
                if (year <= 2023) return false;
            }
            return true;
        },

        setOtherCountriesText() {
            const me = this;
            if (me.model.other_country && me.model.other_country.length !== 0 && me.arrayOtherCountries) {
                let str = '';
                me.arrayOtherCountries.forEach(item => {
                    if (me.model.other_country.includes(item.id)) {
                        str += `${item.name}, `
                    }
                });
                return `Si; ${str.slice(0, -2)}.`;
            } else {
                return 'No.';
            }
        },

        setDifferentiatorsChecksText() {
            const me = this;
            let str = '';

            if (me.model.check_initiative_difference_technology === 1) str += 'Tecnología, ';
            if (me.model.check_initiative_difference_business === 1) str += 'Modelo de negocio, ';
            if (me.model.check_initiative_difference_channels === 1) str += 'Personalización, ';
            if (me.model.check_initiative_difference_adoption === 1) str += 'Innovación, ';
            if (me.model.check_initiative_difference_ecosystem === 1) str += 'Impacto ambiental, ';
            if (me.model.check_initiative_difference_other === 1) str += 'Otro, ';

            if (str.length > 0) return `Si; ${str.slice(0, -2)}.`;
            else return 'No.';
        },

        setClientsText() {
            const me = this;
            let str = '';

            if (me.model.clients_type && Array.isArray(me.model.clients_type)) {
                me.model.clients_type.forEach(item => {
                    if (item.selected) str += `${item.name}: ${item.label}, `;
                })
            }

            if (str.length > 0) return `Si; ${str.slice(0, -2)}.`;
            else return 'No.';
        },

        setRecognitionText() {
            const me = this;
            let str = '';

            if (me.model.recognition) {
                me.model.recognition.forEach(item => {
                    str += `${item.name}: "${item.link}", `;
                })
            }

            if (str.length > 0) return `Si; ${str.slice(0, -2)}.`;
            else return 'No.';
        },

        setInvestmentText() {
            const me = this;
            let str = '';

            if (me.model.investment) {
                me.model.investment.forEach(item => {
                    if (item.selected) str += `${item.name}, `;
                })
            }

            if (str.length > 0) return `Si; ${str.slice(0, -2)}.`;
            else return 'No.';
        },

        setCompetitorsText() {
            const me = this;
            let str = '';

            if (me.model.competitors) {
                me.model.competitors.forEach(item => {
                    str += `${item.name}: "${item.link}", `;
                })
            }

            if (str.length > 0) return `Si; ${str.slice(0, -2)}.`;
            else return 'No.';
        },
    },
    mounted() {
        let me = this;
        me.getModel();
        me.getListCountries();
        me.getListCategories();
        me.getAnnualSalesList();
        me.getProjectPhasesList();
        me.getAgesList();
        me.getOtherCountriesList();
    },
};
</script>
<style scoped>
textarea {
    resize: none;
}
</style>
